import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'tt',
    fullName: 'Tatar',
    nativeName: 'Татар',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Гаҗәп нәрсә килә",
    landing_subtitle: "ArgVoid - кушымта һәм уен үсеше студиясе. Тыңлагыз, тиздән яңа әйберләр киләчәк!",
    select_language: "Телне сайлагыз",
    search_placeholder: "Телләрне эзләү ...",
    terms_title: "Хезмәт шартлары",
    policy_title: "Хосусыйлык политикасы",
    cookies_title: "Cookie политикасы",
    terms_content: `
        <strong>1. </strong><br> шартларын кабул итү
        ArgVoid'ка кереп, бу Хезмәт шартлары кабул ителә. Әгәр дә бу шартлар килешелмәгән булса, хезмәтне кулланырга ярамый. <br><br>

        <strong>2. Платформа куллану</strong><br>
        ArgVoid һәм аның кушымталары информацион һәм иҗади максатларда "булганча" бирелә. Хезмәт законлы максатларда гына кулланылырга тиеш.<br><br>

        <strong>3. Тыйган тәртип</strong><br>
        Сайтның зәгыйфьлекләрен куллану, спам яки инфраструктурага рөхсәтсез керергә тырышу катгый тыелган.<br><br>

        <strong>4. Аннан баш тарту</strong><br>
        Платформа һәм хезмәтләр теләсә кайсы вакытта хәбәр итмичә үзгәртелергә мөмкин. Хезмәтнең эш вакыты яки булуы турында гарантия бирелмәгән.
    `,
    policy_content: `
        <strong>1. Мәгълүмат җыю</strong><br>
        Платформа бу вакытта кулланучының аутентификациясен яки хисап язмасын булдыруны таләп итми. Шәхси идентификацион мәгълүмат (исемнәр яки электрон почта адреслары кебек) килүчеләрдән актив җыелмый. <br><br>

        <strong>2. Data</strong><br> куллану
        Төп, аноним булмаган аналитика сайт трафигын аңлау һәм кушымталарны яхшырту өчен җыелырга мөмкин. Бу мәгълүмат аерым кулланучы шәхесләре белән бәйләнмәгән. <br><br>

        <strong>3. Өченче як хезмәтләре</strong><br>
        Өченче як провайдерлары хостинг һәм аналитика хезмәтләре өчен кулланылырга мөмкин. Бу тиешле провайдерларның хосусыйлык практикалары аларның инфраструктурасында эшкәртелгән аноним мәгълүматлар белән идарә итә.<br><br>

        <strong>4. Мәгълүмат куркынычсызлыгы</strong><br>
        Платформаны саклау өчен акыллы куркынычсызлык чаралары тормышка ашырыла. Ләкин, Интернет аша тапшыру ысулы бөтенләй куркынычсыз түгел. <br><br>
    `,
    cookies_content: `
        <strong>1. Cookies һәм җирле саклау нәрсә ул? </strong><br>
        Cookies һәм браузерның җирле саклагычлары - җайланмаларда сакланган кечкенә мәгълүмат файллары, визитлар вакытында конфигурация өстенлекләрен искә төшерү өчен.

        <strong>2. Максат</strong><br> куллану
        LocalStorage браузеры конфигурация көйләүләрен саклау өчен катгый кулланыла, мәсәлән: <br>
        - Тел өстенлекләре<br>
        - Кулланучының интерфейс конфигурациясе (мәсәлән, макет яки тема көйләүләре) <br>
        - Вакытлыча куллану cache<br><br>

        <strong>3. Tracking</strong><br> юк
        Cookies һәм җирле саклагыч реклама яки өченче як күзәтү максатларында кулланылмый. Барлык сакланган мәгълүматлар платформаның төп функциональлеге өчен. <br><br>

        <strong>4. Контроль</strong><br>
        Браузер мәгълүматлары теләсә кайсы вакытта браузер көйләүләре аша чистартылырга мөмкин, ул теләсә нинди җирле конфигурацияләрне торгызачак.
    `,
    cookie_consent_text: "Вебсайтның дөрес эшләвен тәэмин итү өчен без төп куки кулланабыз, мәсәлән, сессияне актив тоту, тел өстенлеген саклау һәм башка махсус конфигурацияләр.",
    read_policy: "Cookie политикасын укыгыз",
    support_title: "Ярдәмгә мөрәҗәгать итегез",
    support_subject_label: "Тема",
    support_message_label: "Хәбәр",
    support_submit_button: "Хәбәр җибәр",
    support_hint: "Искәрмә: бу хәбәр җибәрү өчен сезнең электрон почта кушымтасын ачачак.",
    support_success_msg: "Электрон почта кушымтасын ачу ...",
    support_error_msg: "Хәбәр җибәрә алмады. Зинһар, соңрак кабатлап карагыз.",
    explorer_title: "Тикшерүче",
    history_title: "Тарих",
    animation_title: "Анимация",
    config_title: "Конфигурация",
    tool_mouse: "Сайлагыз (Ctrl + M)",
    tool_brush: "Чиста (Ctrl + B)",
    tool_brush_mode: "Тәртипне алыштырыгыз (Каты / Чиста)",
    tool_eraser: "Сүндергеч (Ctrl + E)",
    tool_brush_size: "Чиста күләмен көйләгез",
    tool_bucket: "Тутыру (Ctrl + F)",
    tool_eyedropper: "Күз күзе",
    tool_grid: "Челтәр (Ctrl + Shift + B)",
    tool_rotate: "Әйләнү (Ctrl + Shift + R)",
    tool_flip_h: "Флип H (Ctrl + Shift + H)",
    tool_flip_v: "Флип V (Ctrl + Shift + V)",
    tool_transpose: "Транспозиция (Ctrl + Shift + T)",
    label_width: "Киңлек",
    label_height: "Биеклек",
    label_frames: "Рамнар саны",
    label_animation: "Анимация стиле",
    label_background_color: "Фон төсе",
    label_interval: "Интервал",
    tool_anim_config: "Анимация конфигурациясе",
    label_new_width: "Яңа киңлек",
    label_new_height: "Яңа биеклек",
    label_apply: "Кулланыгыз",
    label_colors: "Төсләр",
    label_size: "Размер",
    label_tolerance: "Толерантлык",
    val_horizontal: "Горизонталь",
    val_vertical: "Вертикаль",
    val_sequence: "Эзлек",
    val_bounce: "Бонс",
    val_random: "Очраклы",
    val_solid: "Каты",
    val_clear: "Чиста",
    action_add_sheet: "Яңа таблица",
    action_import: "Импорт",
    action_export: "Экспорт",
    action_sort_projects: "Сортлау",
    sort_date_old: "Иң олы",
    sort_date_new: "Иң яңа",
    sort_name_az: "Исем (A-Z)",
    sort_name_za: "Исем (Z-A)",
    action_new_sprite: "Яңа Сприт",
    action_new_project: "Яңа проект",
    modal_save_all_title: "Барлык үзгәрешләрне саклагыз",
    modal_save_all_desc: "Саклау өчен активларны сайлагыз:",
    modal_save_selected: "Сайланганны саклагыз",
    action_saved: "Сакланган",
    modal_create_sprite_title: "Яңа Сприт ясагыз",
    modal_create_project_title: "Яңа проект төзегез",
    modal_add_sheet_title: "Яңа таблицаны өстәгез",
    modal_rename_sheet_title: "Таблицаның исемен үзгәртү",
    modal_rename_sprite_title: "Спритның исемен үзгәртү",
    modal_delete_sprite_title: "Спритны бетерегез",
    modal_delete_project_title: "Проектны бетерү",
    modal_delete_sheet_title: "Битне бетерү",
    placeholder_sprite_name: "Исем",
    placeholder_project_name: "Исем",
    placeholder_sheet_name: "Исем",
    placeholder_new_name: "Яңа исем",
    action_create: "Ярат",
    action_add: "Кушу",
    action_rename: "Исемнең исемен үзгәртү",
    action_duplicate: "Күчермә",
    action_delete: "Бетерү",
    action_cancel: "Баш тарту",
    confirm_delete_sprite: "Сез бу спритны бетерергә телисезме?",
    confirm_delete_project: "Сез бу проектны бетерергә телисезме? Барлык спритлар да бетереләчәк.",
    confirm_delete_sheet: "Сез бу таблицаны бетерергә телисезме?",
    err_select_sprite: "Зинһар, башта спритны сайлагыз.",
    err_select_project: "Зинһар, башта проект сайлагыз.",
    err_name_empty: "Исем буш була алмый.",
    err_sprite_exists: "Бу исем белән сприт бар.",
    err_project_exists: "Бу исемле проект инде бар.",
    err_no_content: "Сакларга эчтәлек юк.",
    err_no_changes: "Саклау өчен үзгәрешләр юк.",
    err_delete_last_sheet: "Соңгы битне бетереп булмый.",
    err_extract_frames: "Рамнарны чыгарып булмады.",
    err_indexeddb: "Locallyирле саклый алмады. Сезнең браузер IndexedDB-ны хупламаска мөмкин.",
    msg_upload_success: "Йөкләү уңышлы: {0}",
    msg_upload_failed: "Йөкләү уңышсыз: {0}",
    msg_save_success: "Уңышлы саклагыз.",
    msg_saving: "Саклау ...",
    msg_multi_save_result: "Сакланган {0} активлар. {1} уңышсызлыклар.",
    menu_title: "Меню",
    menu_save: "Саклагыз",
    menu_save_all: "Барысын да саклагыз",
    menu_support: "Ярдәмгә мөрәҗәгать итегез",
    label_local_storage: "Localирле саклагыч",
    label_sign_in: "Керегез",
    modal_export_title: "Спритны экспортлагыз",
    label_filename: "Файлның исеме",
    label_format: "Формат",
    action_export_confirm: "Экспорт",
};

export default translations;
